import styled, { keyframes } from 'styled-components'
import { Button } from '~/shared/components/Button'
import { Container } from '~/shared/components/Container'
import { COLORS } from '~/shared/constants/uiConstants'

const slideInFromRight = keyframes`
  from {opacity: 0;transform: translateX(10%)}
  to {opacity: 1;transform: translateX(0)}`

export const Styles = {
  Root: styled.div`
    width: 100%;
    height: calc(100dvh - var(--header-height));
    overflow: hidden;

    &:before {
      position: absolute;
      z-index: -1;
      inset: 0;
      content: '';
      background-color: ${COLORS.GRAY_100};
    }
  `,

  StyledContainer: styled(Container)`
    padding: 24px 16px;
    justify-content: space-between;
  `,

  Question: styled.p`
    font-size: 22px;
    line-height: 24px;
    font-weight: 700;
    margin-bottom: 16px;
    color: ${COLORS.BLACK};
  `,

  ImageContainer: styled.div`
    position: relative;
    box-shadow: 0 8px 12px -6px #3e0b8f1a;
    border-radius: 12px;
    min-height: 258px;
  `,

  TextWrapper: styled.div`
    position: absolute;
    bottom: 16px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
  `,

  Title: styled.h1`
    text-align: center;
    font-size: 22px;
    line-height: 24px;
    font-weight: 700;
    color: ${COLORS.BLACK};
    margin-bottom: 8px;
  `,

  Subtitle: styled.h2`
    text-align: center;
    font-size: 14px;
    line-height: 18px;
    color: ${COLORS.BLACK};
  `,

  ButtonWrapper: styled.div`
    display: flex;
    width: 100%;
    gap: 14px;
    animation: ${slideInFromRight} 0.4s ease-out;
  `,

  StyledButton: styled(Button)<{ $isSelected?: boolean }>`
    background: ${COLORS.WHITE};
    border: 1px solid ${COLORS.GRAY_400};
    color: ${COLORS.BLACK};
    font-size: 14px;
    line-height: 18px;
    font-weight: 700;
    align-items: center;
    display: inline-flex;

    ${({ $isSelected }) =>
      $isSelected &&
      `
        background: ${COLORS.PURPLE_100};
        border: 1px solid ${COLORS.PURPLE_500};
      `}
  `,

  ButtonIcon: styled.img`
    margin-right: 8px;
  `,
} as const
